var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{class:{four:!_vm.highLight,'four-high-light':_vm.highLight},attrs:{"border":"1"}},[_vm._m(0),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td'),_c('td')])
},function (){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td'),_c('td')])
}]

export { render, staticRenderFns }